<template>
  <div id="selectidentity">
    <div class="top"><img src="../assets/img/logo2.png" alt="" /></div>
    <div class="content">
      <div class="goBack" @click="goBack">
        <i class="el-icon-d-arrow-left"></i>
        返回
      </div>
      <div class="selectArea">
        <div class="titleArea">
          <h4>请选择对应身份进入</h4>
        </div>
        <div
          class="outerarea"
          :style="{ flexDirection: flag == '1' ? 'row' : 'column' }"
        >
          <div class="freshgraduate" @click="jump('1')">
            <img src="@/assets/img/1.png" alt="" />应届毕业生
          </div>
          <!-- <div class="freshgraduate" @click="jump('2')">
            <img src="@/assets/img/2.png" alt="" />历届毕业生
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "应届毕业生",

      flag: 0,
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
    },
    jump(flag) {
      if (flag == "1") {
        this.$router.push("/freshgraduate?flag=1"); //应届毕业生
        sessionStorage.setItem("graduating", "1");
      } else {
        this.$router.push("/formerstudents?flag=1"); //历届毕业生
        sessionStorage.setItem("graduating", "2");
      }
    },
    goBack() {
      this.$router.push("/dataRequest"); //返回
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#selectidentity {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-around;
  background: rgba(245, 245, 245, 1);
  .top {
    width: 25rem;
    height: 5rem;
    box-sizing: border-box;
    margin: 10px 0;

    > img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    width: 85%;
    height: auto;
    max-width: 1000px;
    min-height: 74%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    position: relative;
    border-radius: 10px;
    position: relative;
    overflow-y: auto;
    .goBack {
      position: absolute;
      left: 15px;
      top: 15px;
      font-size: 15px;
      &:hover {
        cursor: pointer;
      }
    }
    .selectArea {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: space-around;
      box-shadow: 0 10px 10px #d2d2d2;
      background-color: rgba(243, 243, 243, 0.39);
      .titleArea {
        color: #24b1ff;
        font-size: 24px;
        margin-top: 100px;
      }
      .outerarea {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        .freshgraduate {
          width: 50%;
          max-width: 350px;
          height: auto;
          // border: 2px solid #000;
          background-color: #f8f8f8a6;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #24b1ff;
          font-size: 20px;
          font-weight: 700;
          border-radius: 10px;
          margin: 10px 40px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
          transition: 0.7s;
          box-sizing: border-box;
          padding: 30px 0;
          &:hover {
            background: #c0c0c0c4;
            cursor: pointer;
            // color: #fff;
          }
          img {
            width: 60%;
          }
        }

        .formerstudents {
          width: 280px;
          height: 200px;
          border: 2px solid #000;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #24b1ff;
          font-size: 30px;
          font-weight: 700;
          margin: 10px 30px;
          &:hover {
            background: #24b1ff;
            cursor: pointer;
            color: #fff;
            transition: 0.7s;
          }
        }
      }
      /deep/.el-radio__label {
        font-size: 20px !important;
        width: 30px;
        height: 30px;
      }
      /deep/ .el-radio__inner {
        width: 40px;
        height: 40px;
      }
      /deep/ .el-radio__inner::after {
        width: 14px;
        height: 14px;
      }
    }
  }
}
</style>
